export const TYPES = {
    DARK: 'DARK',
    ERROR: 'ERROR',
    INFO: 'INFO',
    LIGHT: 'LIGHT',
    SUCCESS: 'SUCCESS',
    WARNING: 'WARNING',
};
export const POSITIONS = {
    BOTTOM: 'BOTTOM',
    'BOTTOM-RIGHT': 'BOTTOM-RIGHT',
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
    TOP: 'TOP',
    'TOP-RIGHT': 'TOP-RIGHT',
};
export const OPPOSITE_POSITIONS = {
    BOTTOM: POSITIONS.TOP,
    'BOTTOM-RIGHT': POSITIONS['TOP-RIGHT'],
    LEFT: POSITIONS.RIGHT,
    RIGHT: POSITIONS.LEFT,
    TOP: POSITIONS.BOTTOM,
    'TOP-RIGHT': POSITIONS['BOTTOM-RIGHT'],
};
export const ARROW_SIZE = 8;
//# sourceMappingURL=constants.js.map